/***************************************************************************************/ 
 /* This file is generated. Do not edit by hand unless you 100% know what you're doing.. */ 
 /***************************************************************************************/ 
 
export enum UserVarKey { 
    AbandonedCartCounter = "AbandonedCartCounter",
    AbandonedCartDate = "AbandonedCartDate",
    AbandonedCartMessageDate = "AbandonedCartMessageDate",
    AccessCode = "AccessCode",
    AccountType = "AccountType",
    AfterMergeQNode = "AfterMergeQNode",
    AfterNavigateHolder = "AfterNavigateHolder",
    AnsweringMachine = "AnsweringMachine",
    AutoPayEnabled = "AutoPayEnabled",
    Birthdate = "Birthdate",
    Channel = "Channel",
    CollectionsAgentEmailPaymentURL = "CollectionsAgentEmailPaymentURL",
    CollectionsAgentSMSPaymentURL = "CollectionsAgentSMSPaymentURL",
    CollectionsAgentVoicemailMessage = "CollectionsAgentVoicemailMessage",
    ConversationStarted = "ConversationStarted",
    CRMId = "CRMId",
    CRMStatus = "CRMStatus",
    CronReceiptType = "CronReceiptType",
    CurrentURL = "CurrentURL",
    CurrentVoiceAgent = "CurrentVoiceAgent",
    Date = "Date",
    DaVinciCode = "DaVinciCode",
    DiscountArray = "DiscountArray",
    EmailReceiptType = "EmailReceiptType",
    EmailRecipientsList = "EmailRecipientsList",
    EmailType = "EmailType",
    EntityAccountTerm = "EntityAccountTerm",
    EntityAction = "EntityAction",
    EntityContactMethod = "EntityContactMethod",
    EntityDate = "EntityDate",
    EntityDuration = "EntityDuration",
    EntityEmail = "EntityEmail",
    EntityFeature = "EntityFeature",
    EntityItem = "EntityItem",
    EntityLeaseTerm = "EntityLeaseTerm",
    EntityLocation = "EntityLocation",
    EntityNumber = "EntityNumber",
    EntityPaymentOption = "EntityPaymentOption",
    EntityPersonName = "EntityPersonName",
    EntityPhonenumber = "EntityPhonenumber",
    EntitySize = "EntitySize",
    EntityTime = "EntityTime",
    FBMessengerId = "FBMessengerId",
    FilterFeatures = "FilterFeatures",
    FilterSize = "FilterSize",
    FilterStores = "FilterStores",
    FlowVoiceBrainHandler = "FlowVoiceBrainHandler",
    FMSError = "FMSError",
    FMSplus0PastDueChannelArray = "FMSplus0PastDueChannelArray",
    FMSplusp10PastDueChannelArray = "FMSplusp10PastDueChannelArray",
    FMSplusp14PastDueChannelArray = "FMSplusp14PastDueChannelArray",
    FMSplusp1PastDueChannelArray = "FMSplusp1PastDueChannelArray",
    FMSplusp2PastDueChannelArray = "FMSplusp2PastDueChannelArray",
    FMSplusp30PastDueChannelArray = "FMSplusp30PastDueChannelArray",
    FMSplusp3PastDueChannelArray = "FMSplusp3PastDueChannelArray",
    FMSplusp45PastDueChannelArray = "FMSplusp45PastDueChannelArray",
    FMSplusp5PastDueChannelArray = "FMSplusp5PastDueChannelArray",
    FMSplusp7PastDueChannelArray = "FMSplusp7PastDueChannelArray",
    FMSplusRecurringPastDueChannelArray = "FMSplusRecurringPastDueChannelArray",
    GotoQNode = "GotoQNode",
    HasBeenEscalated = "HasBeenEscalated",
    HasCompletedProfile = "HasCompletedProfile",
    HasConfirmedProfile = "HasConfirmedProfile",
    HasProvidedFeedback = "HasProvidedFeedback",
    HasSeenAccountLoginMenu = "HasSeenAccountLoginMenu",
    HasSeenAccountMenu = "HasSeenAccountMenu",
    HasSeenAnythingElseMenu = "HasSeenAnythingElseMenu",
    HasSeenChangeAccountMenu = "HasSeenChangeAccountMenu",
    HasSeenContactMenu = "HasSeenContactMenu",
    HasSeenCostMenu = "HasSeenCostMenu",
    HasSeenFeatureMenu = "HasSeenFeatureMenu",
    HasSeenGSExistingMenu = "HasSeenGSExistingMenu",
    HasSeenGSPotentialMenu = "HasSeenGSPotentialMenu",
    HasSeenInventoryMenu = "HasSeenInventoryMenu",
    HasSeenLeaseTermsMenu = "HasSeenLeaseTermsMenu",
    HasSeenMoveMenu = "HasSeenMoveMenu",
    HasSeenProblemMenu = "HasSeenProblemMenu",
    HasSeenPurcHaseProcessMenu = "HasSeenPurcHaseProcessMenu",
    HasSeenSizeMenu = "HasSeenSizeMenu",
    HasSeenSMSDisclaimer = "HasSeenSMSDisclaimer",
    HasShortProfile = "HasShortProfile",
    HasSwivlInteraction = "HasSwivlInteraction",
    HasUnhandled = "HasUnhandled",
    InAbandonedCartWorkflow = "InAbandonedCartWorkflow",
    IncomingCallNumber = "IncomingCallNumber",
    InsideBusinessHours = "InsideBusinessHours",
    Intent = "Intent",
    IntentProgress = "IntentProgress",
    InterruptedProfileCollect = "InterruptedProfileCollect",
    InventoryDate = "InventoryDate",
    IsBlocked = "IsBlocked",
    IsMobile = "IsMobile",
    IsQuickReplying = "IsQuickReplying",
    IsTakenOver = "IsTakenOver",
    IsUpdatingProfile = "IsUpdatingProfile",
    LanguageToChangeFrom = "LanguageToChangeFrom",
    LastAgentName = "LastAgentName",
    LastAMDStatus = "LastAMDStatus",
    LastInput = "LastInput",
    LastIntent = "LastIntent",
    LastLoadDataRun = "LastLoadDataRun",
    LeadHasSentEmailReceipt = "LeadHasSentEmailReceipt",
    LeadHasSentToFMS = "LeadHasSentToFMS",
    LeadStatus = "LeadStatus",
    LeaseBalances = "LeaseBalances",
    LeaseOptionsFormatted = "LeaseOptionsFormatted",
    LLMButtonLabels = "LLMButtonLabels",
    LLMButtons = "LLMButtons",
    LLMExitConversation = "LLMExitConversation",
    LLMExitReason = "LLMExitReason",
    LLMNotesForHuman = "LLMNotesForHuman",
    LLMResponse = "LLMResponse",
    LLMResponse1 = "LLMResponse1",
    LLMResponse2 = "LLMResponse2",
    LLMResponse3 = "LLMResponse3",
    LLMResponse4 = "LLMResponse4",
    LLMResponse5 = "LLMResponse5",
    LLMResponseID = "LLMResponseID",
    LLMSearchErrorCount = "LLMSearchErrorCount",
    LLMStructuredErrorCount = "LLMStructuredErrorCount",
    Location = "Location",
    Locations = "Locations",
    NearbyLocationsAndUnitsText = "NearbyLocationsAndUnitsText",
    NewLanguageName = "NewLanguageName",
    Notes = "Notes",
    PaymentLinkError = "PaymentLinkError",
    Persona = "Persona",
    PersonaCollectHolder = "PersonaCollectHolder",
    PhoneVerifiedUntil = "PhoneVerifiedUntil",
    PreviousChannelHolder = "PreviousChannelHolder",
    ProfileCollectHolder = "ProfileCollectHolder",
    QNode = "QNode",
    QuestBreadcrumb = "QuestBreadcrumb",
    QueueOnVoicePickup = "QueueOnVoicePickup",
    ReferralCounter = "ReferralCounter",
    ReferralEmail = "ReferralEmail",
    ReferralName = "ReferralName",
    ReferralPhone = "ReferralPhone",
    ReferredBy = "ReferredBy",
    ReferredByName = "ReferredByName",
    ReserveCounter = "ReserveCounter",
    ReviewFeedbackPersona = "ReviewFeedbackPersona",
    ReviewNPSFeedback = "ReviewNPSFeedback",
    ReviewNPSScore = "ReviewNPSScore",
    ReviewNPSTopic = "ReviewNPSTopic",
    SelectedStoreFromSMS = "SelectedStoreFromSMS",
    Sentiment = "Sentiment",
    SentimentScore = "SentimentScore",
    ShortURL = "ShortURL",
    ShouldNotAskToChangeLanguage = "ShouldNotAskToChangeLanguage",
    SMSesSent = "SMSesSent",
    spotReferralDate = "spotReferralDate",
    spotRentDate = "spotRentDate",
    StepVoiceBrainHandler = "StepVoiceBrainHandler",
    StoreSelectorViewCounter = "StoreSelectorViewCounter",
    SwivlEmail  = "SwivlEmail ",
    SwivlName = "SwivlName",
    SwivlPhone = "SwivlPhone",
    SwivlPostalCode = "SwivlPostalCode",
    TakeoverAgentId = "TakeoverAgentId",
    TemporaryFMSID = "TemporaryFMSID",
    TempPhoneNumber = "TempPhoneNumber",
    Time = "Time",
    TranscriptAccessExpiresAt = "TranscriptAccessExpiresAt",
    Unit = "Unit",
    UnitNumbers = "UnitNumbers",
    ValidatedUntil = "ValidatedUntil",
    VoiceLocation = "VoiceLocation",
    VoiceRentAUnitDate = "VoiceRentAUnitDate",
    WantsToStoreVehicle = "WantsToStoreVehicle",
    WantToSearchAnotherStore = "WantToSearchAnotherStore",
    WantToShopByPrice = "WantToShopByPrice",
}